import React, { createContext, useContext, useState, useEffect } from "react";

// Create the context
const NavContext = createContext();

// Create a provider component
export const NavProvider = ({ children }) => {
  const [activeLink, setActiveLink] = useState("Home");
  console.log(activeLink);

  return (
    <NavContext.Provider value={{ activeLink, setActiveLink }}>
      {children}
    </NavContext.Provider>
  );
};

// Custom hook to use NavContext
export const useNav = () => useContext(NavContext);
